import React from 'react';
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import { Tabs, Tab, Box } from '@mui/material';
import SingleClientQuestionnaires from './SingleClientQuestionnaires';
import MultiClientQuestionnaires from './MultiClientQuestionnaires';
import axios from "../../../utils/fvAxios";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

function TabPanel(props) {
    const { children, value, index } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
      >
        {value === index && <Box p={3}  style={{backgroundColor:"#fff",padding:"20px"}}>{children}</Box>}
      </div>
    );
  }

export default function FindyourClientsTab({Vendid}) {
  const [GetOpenClients, setGetOpenClients] = React.useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true); 

  useEffect(() => {
    axios.get("Prequalification/GetOpenClients?vendorId="+Vendid
    ).then((res) => {
      if (res.data.responseCode === 100) {
        setGetOpenClients(res?.data?.data)
      }
      else {
        setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }) .finally(() => {
      setIsLoading(false); // Set isLoading to false after the API call is completed (either success or error)
    });

  }, []);
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  return (
    
    <div>
        {isLoading ? <Backdrop
 sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
 open={isLoading}

 >
<CircularProgress color="inherit" />
 </Backdrop>: (
          <Box >
        <Tab
          component="li"
          label="Single-Client Questionnaires"
          className={`nav-item${value === 0 ? ' active' : 'nonactive'}`}
          onClick={(event) => handleChange(event, 0)}
        />
        <Tab
          component="li"
          label="Multi-Client Questionnaires"
          className={`nav-item${value === 1 ? ' active' : 'nonactive'}`}
          onClick={(event) => handleChange(event, 1)}
        />
        <style>{`
          .nav-item.active {
            background-color: #fff;
            color: #667085;
            border: 1px solid #e4e7ec;
            border-bottom: none;
          }
          .nav-item.nonactive {
            background-color: #E4E7EC;
            color: #f2f4f7;
            border: 1px solid #e4e7ec;
            border-bottom: none;
          }
        `}</style>
      {/* </Box> */}
      <TabPanel value={value} index={0}>
      <SingleClientQuestionnaires Get={GetOpenClients} Vend={Vendid}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
     <MultiClientQuestionnaires  Get={GetOpenClients}  Vend={Vendid}/>
      </TabPanel>
      </Box>
         )}
    </div>

  )
}
